import styles from "../Tabelas.module.css";
import Container from "../../../../components/components-ui/Container/Container";
import Button from "../../../../components/components-ui/Button/Button";
import { Grid, Col } from "../../../../components/Grid";
import { Box } from "@mui/material";
import api from "../../../../services/Api";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const API_CREATE_ACAO = "/acao/create";
const API_EDIT_ACAO = "/acao/edit/";
const API_SHOW_ACAO = "/acao/show/";

export default function Action() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [acao, setAcao] = useState([]);

  const createAcao = async (values) => {
    const data = {
      Acao: values?.nomeAcao,
      NomeGrupo: values?.nomeGrupo,
      NomeMenu: values?.nomeMenu,
      Link: values?.link,
      NomeIcon: values?.nomeIcon,
      OrdenacaoMenu: values?.ordenacaoMenu,
      MenuPrincipal: values?.menuPrincipal,
      OptionNomePai: values?.nomePai,
    };

    await api
      .post(API_CREATE_ACAO, data)
      .then((res) => {
        if (res.data.error === 0) {
          toast.success(res.data.msg);
          navigate("/usina/acao");
          return;
        }
        toast.error("Algo de errado aconteceu: " + res.data.msg);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Algo de errado aconteceu: " + error.message);
      });
  };

  const editAcao = async (values) => {
    const data = {
      Acao: values?.nomeAcao,
      NomeGrupo: values?.nomeGrupo,
      NomeMenu: values?.nomeMenu,
      Link: values?.link,
      NomeIcon: values?.nomeIcon,
      OrdenacaoMenu: values?.ordenacaoMenu,
      MenuPrincipal: values?.menuPrincipal,
      OptionNomePai: values?.nomePai,
    };

    await api
      .post(API_EDIT_ACAO + id, data)
      .then((res) => {
        if (res.data.error === 0) {
          toast.success(res.data.msg);
          navigate("/usina/acao");
          return;
        }
        toast.error("Algo de errado aconteceu: " + res.data.msg);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Algo de errado aconteceu: " + error.message);
      });
  };

  const getAcao = async () => {
    await api
      .get(API_SHOW_ACAO + id)
      .then((res) => {
        setAcao(res.data);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Algo de errado aconteceu: " + error.message);
      });
  };

  useEffect(() => {
    if (id) {
      getAcao();
    }
  }, []);

  const validadtionSchema = Yup.object().shape({
    nomeAcao: Yup.string().required("Campo Obrigatório"),
    nomeMenu: Yup.string().when("menuPrincipal", {
      is: true, // verifica se é menu princicpal
      then: (schema) => schema.required("Campo Obrigatório"),
      otherwise: (schema) => schema.notRequired(),
    }),
    nomeIcon: Yup.string(),
    nomeGrupo: Yup.string().when("menuPrincipal", {
      is: true, // verifica se é menu princicpal
      then: (schema) => schema.required("Campo Obrigatório"),
      otherwise: (schema) => schema.notRequired(),
    }),
    link: Yup.string().when("menuPrincipal", {
      is: true, // verifica se é menu princicpal
      then: (schema) => schema.required("Campo Obrigatório"),
      otherwise: (schema) => schema.notRequired(),
    }),
    ordenacaoMenu: Yup.number().when("menuPrincipal", {
      is: true, // verifica se é menu princicpal
      then: (schema) => schema.required("Campo Obrigatório"),
      otherwise: (schema) => schema.notRequired(),
    }),
    menuPrincipal: Yup.boolean(),
    nomePai: Yup.string().when("menuPrincipal", {
      is: true, // verifica se é menu princicpal
      then: (schema) => schema.required("Campo Obrigatório"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
  return (
    <Container>
      <h3>{id ? "Edição de Ação" : "Cadastro de Ação"}</h3>
      <section className={styles.action_section}>
        <Formik
          initialValues={{
            idAcao: acao?.IdAcao || "",
            nomeAcao: acao?.Acao || "",
            nomeMenu: acao?.NomeMenu || "",
            nomeIcon: acao?.NomeIcon || "",
            nomeGrupo: acao?.NomeGrupo || "",
            link: acao?.Link || "",
            ordenacaoMenu: acao?.OrdenacaoMenu || "",
            menuPrincipal: Boolean(acao?.MenuPrincipal) || false,
            nomePai: acao?.OptionNomePai || "",
          }}
          enableReinitialize={true}
          onSubmit={(values) => (id ? editAcao(values) : createAcao(values))}
          validationSchema={validadtionSchema}
        >
          {({ errors, touched, isSubmitting, values }) => (
            <Form>
              <Box border={1} padding={2}>
                <Grid>
                  {id && (
                    <Col size={1}>
                      <label> Código Ação </label>
                      <Field type="text" name="idAcao" />
                      {errors.idAcao && touched.idAcao ? (
                        <span className={styles.alertError}>
                          {errors.idAcao}
                        </span>
                      ) : null}
                    </Col>
                  )}
                  <Col size={2}>
                    <label> Nome Acão </label>
                    <Field type="text" name="nomeAcao" />
                    {errors.nomeAcao && touched.nomeAcao ? (
                      <span className={styles.alertError}>
                        {errors.nomeAcao}
                      </span>
                    ) : null}
                  </Col>
                </Grid>
                <Grid>
                  <Col size={1}>
                    <label>Menu Principal? </label>
                    <Field name="menuPrincipal">
                      {({ field }) => (
                        <input
                          type="checkbox"
                          checked={field.value}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.menuPrincipal && touched.menuPrincipal ? (
                      <span className={styles.alertError}>
                        {errors.menuPrincipal}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label> Nome Grupo </label>
                    <Field
                      type="text"
                      name="nomeGrupo"
                      disabled={!values.menuPrincipal}
                    />
                    {errors.nomeGrupo && touched.nomeGrupo ? (
                      <span className={styles.alertError}>
                        {errors.nomeGrupo}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label> Nome Pai </label>
                    <Field
                      type="text"
                      name="nomePai"
                      disabled={!values.menuPrincipal}
                    />
                    {errors.nomePai && touched.nomePai ? (
                      <span className={styles.alertError}>
                        {errors.nomePai}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label> Nome Menu / Nome Botão </label>
                    <Field
                      type="text"
                      name="nomeMenu"
                      disabled={!values.menuPrincipal}
                    />
                    {errors.nomeMenu && touched.nomeMenu ? (
                      <span className={styles.alertError}>
                        {errors.nomeMenu}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label> Nome Icon </label>
                    <Field
                      type="text"
                      name="nomeIcon"
                      disabled={!values.menuPrincipal}
                    />
                    {errors.nomeIcon && touched.nomeIcon ? (
                      <span className={styles.alertError}>
                        {errors.nomeIcon}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label> Link </label>
                    <Field
                      type="text"
                      name="link"
                      disabled={!values.menuPrincipal}
                    />
                    {errors.link && touched.link ? (
                      <span className={styles.alertError}>{errors.link}</span>
                    ) : null}
                  </Col>
                  <Col size={1}>
                    <label> Ordenação Menu</label>
                    <Field
                      type="number"
                      name="ordenacaoMenu"
                      disabled={!values.menuPrincipal}
                    />
                    {errors.ordenacaoMenu && touched.ordenacaoMenu ? (
                      <span className={styles.alertError}>
                        {errors.ordenacaoMenu}
                      </span>
                    ) : null}
                  </Col>
                </Grid>
                <Grid justifyContent={"center"}>
                  <Button
                    type="submit"
                    title={"Salvar"}
                    disabled={isSubmitting}
                  />
                  <Button
                    type="button"
                    title="Voltar"
                    color="secondary"
                    onClick={() => {
                      navigate("/usina/acao");
                    }}
                    disabled={isSubmitting}
                  />
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </section>
    </Container>
  );
}
